import type { JuiImageRejection } from '@jump-tech-frontend/core-components/components';
import { CameraI18nKeys } from '@jump-tech-frontend/image-analysis';

export const REJECTION_KEYS: Record<JuiImageRejection['reason'], string | null> = {
  'file-type': 'fileTypeNotAllowedError',
  'file-too-large': 'fileTooLarge',
  'decode-failed': 'uploadImageError',
  'max-images': null
};

export const CAMERA_KEYS: (keyof CameraI18nKeys)[] = [
  'cameraTakePhoto',
  'cameraCancel',
  'cameraPhotosAndFiles',
  'cameraTorchOn',
  'cameraTorchOff',
  'cameraStarting',
  'cameraTurningLightOn',
  'cameraCapturing'
];
